import * as React from 'react';
import { css } from 'aphrodite';
import { t } from '@citrite/translate';
import {
	EmptyDocumentIcon,
	EmptyState,
	MainRegion,
	Modal,
	ModalProps,
} from '@citrite/web-ui-component';
import { hasFeatureCanary } from '@citrite/workspace-ui-platform';
import { isGranularRestartEnabled } from 'App/Activity/useDesktopActions';
import { OpenDesktopButton } from 'Components/ResourceTile/ViewDetails/OpenDesktopButton';
import { RestartDesktopButton } from 'Components/ResourceTile/ViewDetails/RestartDesktopButton';
import {
	WithWorkspaceConfiguration,
	withWorkspaceConfiguration,
} from 'Configuration/withWorkspaceConfiguration';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';
import { Header } from './Header';
import { styles } from './styles';

export interface Props extends ModalProps {
	resource: Resource;
}

class ViewDesktopDetailsImpl extends React.Component<Props & WithWorkspaceConfiguration> {
	private get shouldShowRestart() {
		const { resource, workspaceConfiguration } = this.props;
		if (!resource.poweroffurl) {
			return false;
		}
		const isGranularPowerActionEnabled = hasFeatureCanary(
			workspaceConfiguration,
			FeatureFlag.EnableGranularPowerAction
		);
		return isGranularRestartEnabled(resource, isGranularPowerActionEnabled);
	}

	public render() {
		return (
			<Modal {...this.props}>
				<Header {...this.props} />
				<MainRegion className={css(styles.body)}>
					<div className={css(styles.navBar)}>
						{this.shouldShowRestart && (
							<>
								<RestartDesktopButton resource={this.props.resource} />
								<span className={css(styles.divider)} />
							</>
						)}
						<OpenDesktopButton resource={this.props.resource} />
					</div>
					<div className={css(styles.content)}>
						{this.props.resource.description || this.props.resource.desktophostname ? (
							<div className={css(styles.details)}>
								{this.props.resource.desktophostname && (
									<div className={css(styles.machineName)}>
										<strong>{t('Workspace:machine_name')}</strong>{' '}
										{this.props.resource.desktophostname}
									</div>
								)}
								{this.props.resource.description}
							</div>
						) : (
							<EmptyState icon={EmptyDocumentIcon}>
								{t('Workspace:empty_desktop_details')}
							</EmptyState>
						)}
					</div>
				</MainRegion>
			</Modal>
		);
	}
}

export const ViewDesktopDetails = withWorkspaceConfiguration(ViewDesktopDetailsImpl);
